import React from 'react';
import * as Sentry from '@sentry/react';
import getConfig from 'next/config';

const { sentry } = getConfig().publicRuntimeConfig;
Sentry.init({ ...sentry });

type SentryContextProviderProps = {
    children: React.ReactNode;
};

const SentryContextProvider = ({ children }: SentryContextProviderProps) => <Sentry.ErrorBoundary>{ children }</Sentry.ErrorBoundary>;

const isServer = typeof window === 'undefined';
if (!isServer) {
    window.addEventListener('unhandledrejection', (event) => {
        Sentry.addBreadcrumb({ data: event.reason });
        Sentry.captureException(event.promise);
    });
}

export default SentryContextProvider;
